import { Button, Input, List, message, Modal } from "antd";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { connect } from "dvajs";
import { useTranslation } from "react-i18next";
import { EbookState, MangeExternalModalInfo } from "@/models/ebook";
import { getApplyAccountEXPReq, getExtEmplMsgNotifyRecords } from "@/api/ebook";
import "./index.less";

import ExternalItem from "@/components/Modals/ApplyExternalContactsList/ExternalItem";
export function externalTitleType(type: any, apprStatus: any) {
  switch (type) {
    case 0:
      return { title: "管理者变更", isShowOperator: true };
    case 1:
      switch (apprStatus) {
        case 0:
          return { title: "账号延期提醒", isShowOperator: false };
        case 1:
          return { title: "账号延期成功", isShowOperator: true };
        case 2:
          return { title: "账号延期申请被驳回", isShowOperator: true };
        case 3:
          return { title: "账号延期提醒", isShowOperator: false };
      }
      return;
    case 2:
      return { title: "账号到期提醒", isShowOperator: false };
    case 3:
      return { title: "账号延期成功", isShowOperator: true };
    case 4:
      return { title: "账号延期成功", isShowOperator: true };
    default:
      return { title: "账号延期提醒", isShowOperator: false };
  }
}

export interface externalApplyListNoticeInfo {
  apprStatus: number; // 审核状态, 0:待审核, 1:审核通过, 2:审核驳回, 3:已失效
  desc: string;
  gmtCreate: number;
  operateName: string;
  recordId: number;
  type: number; // 消息类型, 0:管理者变更, 1:延期申请，2:延期提醒 3:管理者延期, 4:管理员延期
}

function ExternalApplyListNoticeList({
  setManageExternalModal,
  manageExternalModal
}: {
  manageExternalModal: MangeExternalModalInfo;
  setManageExternalModal: Function;
}) {
  const { externalApplyVisible } = manageExternalModal;

  const [t] = useTranslation("chat");
  const [externalApplyList, setExternalApplyList] = useState<externalApplyListNoticeInfo[]>([]);

  useEffect(() => {
    async function getNoticeList() {
      const [result, error] = await getExtEmplMsgNotifyRecords();
      if (error) {
        message.error(error);
        return;
      }
      const { msgs } = result;
      const newList: any = externalApplyList.concat(msgs).map((item: any) => {
        return {
          ...item,
          desc: item.desc,
          refuse: false,
          loading: false
        };
      });
      setExternalApplyList(newList);
    }

    if (externalApplyVisible) {
      getNoticeList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalApplyVisible]);

  const handleClouseRefuse = useCallback(
    (item: any, type: boolean) => {
      const newNoticeList: any = externalApplyList.map((n: any) => {
        if (n.recordId === item.recordId) {
          n.refuse = type;
        }
        return n;
      });
      setExternalApplyList(newNoticeList);
    },
    [externalApplyList]
  );

  const handleApplyAccountEXP = useCallback(
    async (item: any, apprStatus: number, apprOption: string) => {
      const [result, error] = await getApplyAccountEXPReq({ applyReason: apprOption });

      handleClouseRefuse(item, false);
      if (error) {
        message.error(error);
        return;
      }
      message.success("操作成功");
    },
    [handleClouseRefuse]
  );

  function handleClose() {
    setManageExternalModal({ ...manageExternalModal, externalApplyVisible: false });
    setTimeout(() => {
      setExternalApplyList([]);
    }, 100);
  }
  const titleNode = useCallback((item) => {
    return externalTitleType(item.type, item.apprStatus)?.title;
  }, []);

  return (
    <Modal
      title="消息通知"
      centered={true}
      visible={externalApplyVisible}
      onCancel={() => {
        handleClose();
      }}
      footer={null}
      width="720px"
      bodyStyle={{ height: 580, overflow: "auto" }}
    >
      <div className="external-contacts">
        {externalApplyList.length ? (
          externalApplyList.map((item: any, key) => {
            return (
              <ExternalItem
                data={item}
                key={key}
                handleClouseRefuse={(ele: any, type: boolean) => {
                  handleClouseRefuse(ele, type);
                }}
                handleAdd={(ele: any, type: number, refusalCause: string) => {
                  handleApplyAccountEXP(ele, type, refusalCause);
                }}
                titleNode={titleNode(item)}
                origin={3}
              />
            );
          })
        ) : (
          <p style={{ margin: "20px auto" }}>暂无数据</p>
        )}
      </div>
    </Modal>
  );
}

function mapStateToProps({ ebook }: { ebook: EbookState }) {
  return {
    manageExternalModal: {
      externalApplyVisible: ebook.manageExternalModal.externalApplyVisible
    }
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setManageExternalModal(payload: boolean) {
      dispatch({ type: "ebook/setManageExternalModal", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalApplyListNoticeList);
